export default "__VITE_ASSET__941ac82d__"